import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Dialog,
  DialogContent,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Button,
  Grid,
  Paper,
  Typography,
  Chip,
} from '@mui/material';
import {
  Delete,
  Star,
  StarBorder,
  Add,
  Close,
  ChevronLeft,
  ChevronRight,
  PhotoCamera,
} from '@mui/icons-material';
import api from '../services/api';
import { toast } from 'react-toastify';

export default function GaleriaFotos({ veiculoId, fotos, onUpdate }) {
  const [fotoSelecionada, setFotoSelecionada] = useState(null);
  const [indexAtual, setIndexAtual] = useState(0);
  const [uploading, setUploading] = useState(false);

  const handleUploadFoto = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      toast.error('Selecione uma imagem válida');
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
    formData.append('is_principal', fotos.length === 0 ? 'true' : 'false');

      await api.post(`/veiculos/${veiculoId}/galeria`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      toast.success('Foto adicionada com sucesso!');
      if (onUpdate) onUpdate();
    } catch (error) {
      toast.error(error.response.data.error || 'Erro ao enviar foto');
    } finally {
      setUploading(false);
    }
  };

  const handleDeletarFoto = async (fotoId) => {
    if (!window.confirm('Deseja realmente remover esta foto')) return;

    try {
      await api.delete(`/veiculos/${veiculoId}/galeria/${fotoId}`);
      toast.success('Foto removida com sucesso!');
      if (fotoSelecionada) setFotoSelecionada(null);
      if (onUpdate) onUpdate();
    } catch (error) {
      toast.error(error.response.data.error || 'Erro ao deletar foto');
    }
  };

  const handleDefinirPrincipal = async (fotoId) => {
    try {
      await api.put(`/veiculos/${veiculoId}/galeria/${fotoId}/principal`);
      toast.success('Foto principal definida!');
      if (onUpdate) onUpdate();
    } catch (error) {
      toast.error(error.response.data.error || 'Erro ao definir foto principal');
    }
  };

  const handleOpenVisualizacao = (foto, index) => {
    setFotoSelecionada(foto);
    setIndexAtual(index);
  };

  const handleCloseVisualizacao = () => {
    setFotoSelecionada(null);
  };

  const handleProxima = () => {
    if (indexAtual < fotos.length - 1) {
      const novoIndex = indexAtual + 1;
      setIndexAtual(novoIndex);
      setFotoSelecionada(fotos[novoIndex]);
    }
  };

  const handleAnterior = () => {
    if (indexAtual > 0) {
      const novoIndex = indexAtual - 1;
      setIndexAtual(novoIndex);
      setFotoSelecionada(fotos[novoIndex]);
    }
  };

  if (!fotos || fotos.length === 0) {
    return (
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <PhotoCamera sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Nenhuma foto na galeria
        </Typography>
        <input
          accept="image/*"
          style={{ display: 'none' }}
          id="upload-primeira-foto"
          type="file"
          onChange={handleUploadFoto}
          disabled={uploading}
        />
        <label htmlFor="upload-primeira-foto">
          <Button
            variant="contained"
            component="span"
            startIcon={<Add />}
            disabled={uploading}
            sx={{ mt: 2 }}
          >
                {uploading ? 'Enviando...' : 'Adicionar Foto'}
          </Button>
        </label>
      </Paper>
    );
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="subtitle2">
          Galeria de Fotos ({fotos.length})
        </Typography>
        <input
          accept="image/*"
          style={{ display: 'none' }}
          id="upload-nova-foto"
          type="file"
          onChange={handleUploadFoto}
          disabled={uploading}
        />
        <label htmlFor="upload-nova-foto">
          <Button
            variant="outlined"
            component="span"
            size="small"
            startIcon={<Add />}
            disabled={uploading}
          >
                {uploading ? 'Enviando...' : 'Nova Foto'}
          </Button>
        </label>
      </Box>

      <ImageList cols={4} gap={8}>
        {fotos.map((foto, index) => (
          <ImageListItem key={foto.id}>
            <img
              src={foto.url}
              alt={`Foto ${index + 1}`}
              loading="lazy"
              style={{
                height: 180,
                objectFit: 'cover',
                cursor: 'pointer',
                      border: foto.is_principal ? '3px solid #d62828' : 'none',
              }}
              onClick={() => handleOpenVisualizacao(foto, index)}
            />
            <ImageListItemBar
              actionIcon={
                <Box>
                  <IconButton
                    onClick={() => handleDefinirPrincipal(foto.id)}
                    sx={{ color: 'white' }}
                    size="small"
                  >
                    {foto.is_principal ? <Star /> : <StarBorder />}
                  </IconButton>
                  <IconButton
                    onClick={() => handleDeletarFoto(foto.id)}
                    sx={{ color: 'white' }}
                    size="small"
                  >
                    <Delete />
                  </IconButton>
                </Box>
              }
              position="top"
            />
            {foto.is_principal && (
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: 'rgba(214, 40, 40, 0.9)',
                  color: 'white',
                  textAlign: 'center',
                  py: 0.5,
                }}
              >
                <Typography variant="caption" fontWeight="bold">
                  PRINCIPAL
                </Typography>
              </Box>
            )}
          </ImageListItem>
        ))}
      </ImageList>

      {/* Dialog de Visualização */}
      <Dialog
        open={!!fotoSelecionada}
        onClose={handleCloseVisualizacao}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent sx={{ p: 0, position: 'relative', backgroundColor: 'black' }}>
          <IconButton
            onClick={handleCloseVisualizacao}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'white',
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 1,
            }}
          >
            <Close />
          </IconButton>

          {fotoSelecionada && (
            <Box sx={{ position: 'relative' }}>
              <img
                src={fotoSelecionada.url}
                alt="Visualização"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '80vh',
                  objectFit: 'contain',
                }}
              />

              {indexAtual > 0 && (
                <IconButton
                  onClick={handleAnterior}
                  sx={{
                    position: 'absolute',
                    left: 16,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'white',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                  }}
                >
                  <ChevronLeft fontSize="large" />
                </IconButton>
              )}

              {indexAtual < fotos.length - 1 && (
                <IconButton
                  onClick={handleProxima}
                  sx={{
                    position: 'absolute',
                    right: 16,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: 'white',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                  }}
                >
                  <ChevronRight fontSize="large" />
                </IconButton>
              )}

              <Box
                sx={{
                  position: 'absolute',
                  bottom: 16,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  px: 2,
                  py: 1,
                  borderRadius: 1,
                }}
              >
                <Typography variant="body2">
                  {indexAtual + 1} / {fotos.length}
                  {fotoSelecionada.is_principal && (
                    <Chip
                      label="PRINCIPAL"
                      size="small"
                      color="error"
                      sx={{ ml: 2 }}
                    />
                  )}
                </Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
